import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Svg } from '@ohif/ui';
import NotFoundViewport from '../components/NotFoundViewport';


export function NotFound() {
  const { t } = useTranslation('NotFound');

  useEffect(() => {
    document.title = `HarpiAI APP | ${t('Page Not Found')}`;
  }, [t]);

  return (
    <NotFoundViewport>
      <div className="w-full text-center flex flex-col items-center">
        <h1 className="text-[100px] md:text-[140px] leading-none font-black text-transparent bg-clip-text bg-gradient-to-br from-blue-400 to-indigo-600 drop-shadow-xl mb-4">
          404
        </h1>

        <h2 className="text-2xl md:text-3xl font-bold tracking-tight text-white mb-4">
          {t('Page Not Found')}
        </h2>

        <Link
          className="flex w-full sm:w-auto justify-center rounded-xl bg-gradient-to-r from-blue-600 to-indigo-600 px-10 py-3.5 text-sm font-semibold text-white shadow-md hover:from-blue-500 hover:to-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 transition-all duration-200 transform active:scale-[0.98]"
          to={'/'}
        >
          {t('Go back to the Study List')}
        </Link>
      </div>
    </NotFoundViewport>
  );
};


export function NotFoundServer() {
  const { t } = useTranslation('NotFound');

  useEffect(() => {
    document.title = `HarpiAI APP | ${t('Not found server')}`;
  }, [t]);

  return (
    <NotFoundViewport>
      <div className="w-full text-center flex flex-col items-center">
        <div className="mb-8 p-6 rounded-3xl">
          <Svg name="not-found" className="w-24 h-24 text-indigo-400 opacity-90" />
        </div>

        <h2 className="text-xl font-bold tracking-tight text-white mb-10">
          {t('Not found server')}
        </h2>

        {/* <p className="text-white text-sm md:text-base max-w-sm">
          Estamos com dificuldades de nos comunicar com o servidor no momento. Por favor, tente novamente mais tarde.
        </p> */}
      </div>
    </NotFoundViewport>
  );
};


export function NotFoundStudy() {
  const { t } = useTranslation('NotFound');
  const [error, setError] = useState('');

  useEffect(() => {
    const historyError = window.history.state;
    if (typeof historyError === 'string' && historyError) {
      setError(historyError);
    }
    document.title = `HarpiAI APP | ${t('Study error')}`;
  }, [t]);

  return (
    <NotFoundViewport>
      <div className="w-full text-center flex flex-col items-center">
        <div className="mb-8 p-6 rounded-3xl">
          <Svg name="not-found" className="w-24 h-24 text-blue-400 opacity-90" />
        </div>

        <h2 className="text-2xl md:text-3xl font-bold tracking-tight text-white mb-3">
          {error ? t(error) : t('Study error')}
        </h2>

        <p className="text-white text-slate-400 text-sm md:text-base max-w-sm mb-10">
          {t('Not found study message')}{' '}
          <Link
            className="font-semibold text-blue-400 hover:text-blue-300 transition-colors"
            to={'/'}
          >
            {t('study list')}
          </Link>
        </p>
      </div>
    </NotFoundViewport>
  );
};
